import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';
import { CommonMap } from 'client/tracking/maps/common';
import { IndustryTrackingConstant } from './constant';

const signInEvent = TrackingEvent.actionCompleted(
  IndustryTrackingConstant.ACTION_SIGN_IN,
  IndustryTrackingConstant.LOGIN
);
const contactUsEvent = TrackingEvent.actionCompleted(
  IndustryTrackingConstant.ACTION_CONTACT_EDMUNDS,
  IndustryTrackingConstant.CONTACT_US
);
const pressHeaderLogoEvent = TrackingEvent.actionCompleted(
  TrackingConstant.ACTION_RESET_NAVIGATION,
  TrackingConstant.ACTION_RESET_NAVIGATION
);
const pressHeaderMenuEvent = TrackingEvent.actionCompleted(
  TrackingConstant.ACTION_TOOL_SELECT,
  TrackingConstant.ACTION_TOOL_SELECT
);

const map = {
  nav_sign_in: signInEvent,
  nav_contact_us: contactUsEvent,
  press_header_logo: pressHeaderLogoEvent,
  press_header_nav: pressHeaderMenuEvent,
  press_header_submenu: pressHeaderMenuEvent,
  press_header_contact: contactUsEvent,
  press_header_contact_submenu: contactUsEvent,
  press_header_sign_in: signInEvent,
  press_header_hamburger: pressHeaderMenuEvent,
};

export const TrackingMap = {
  ...CommonMap,
  ...map,
};
